import { useStore } from "./index";

const hasDeviceInfo = () => Boolean(useStore.getState().deviceInfo?.imei);

const hasStoreInfo = () => {
	const { location, config } = useStore.getState();

	return Boolean(location?.id && config);
};

export { hasDeviceInfo, hasStoreInfo };
